import React from "react";
import { Flex, Typography } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import "./RegionNotEligiblePlaceholder.less";

const { Text } = Typography;

const RegionNotEligiblePlaceholder = ({ programName }) => (
  <Flex
    vertical
    align="center"
    justify="center"
    gap={12}
    className="mc-region-not-eligible-placeholder"
  >
    <GlobalOutlined style={{ fontSize: 36, color: "#7a7a83" }} />
    <Text strong style={{ maxWidth: 320 }}>
      {programName} is not available in Germany, India, or Switzerland.
    </Text>
  </Flex>
);

export default RegionNotEligiblePlaceholder;
